import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from "react-router-dom";
import Layout from '../../parts/Layout';
import helpers from '../../../services/helpers';
import Swal from 'sweetalert2';
import Loader from '../../parts/Loader';
import initTreeView from '../../../services/initTreeView';
import { getApiData } from '../../../services/apiService';
import { BsCheckCircleFill, BsWrenchAdjustable   } from "react-icons/bs";
import { GiBroom } from "react-icons/gi";
import { BsCalendar2CheckFill } from "react-icons/bs";
import { VscSignOut } from "react-icons/vsc";
 
export default function PolarCareDashboard (){
    const isMounted = useRef(false);
    const [loading, setLoading] = useState(0);
    const navigate = useNavigate();
    const [widget_data, setWidgetData] = useState({
        "OK": 0,
        "SERVICE": 0,
        "OUT": 0,
        "CLEAN DUE": 0,
        "CLEANED": 0,
    });

   
    useEffect(() => {// 2. Check the guard
        //if (isMounted.current) {
        //return; 
       // }

        //isMounted.current = true;
        
        initTreeView()
        //Mounted


        async function fetchWidgetData(){
            let filter = '?store_id='+helpers.getStoreID()+'&'
            filter = filter.slice(0, -1)

            const endpoint = helpers.createServiceHubUrl('v1/product-details/stats')
            const res = await getApiData(endpoint)
            if(res.status === 'error'){
                setLoading(0)
                Swal.fire({
                    text: res.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                    allowOutsideClick: false
                })
            }
            else{
                setWidgetData(res)
                setLoading(0)
            }
        }

        fetchWidgetData()
    }, []);

    return (
        <>
        {/* <Layout page_title={"Hello, " + helpers.getUserName()} menu="home" breadcrumbs={false}> */}
        <Layout page_title="PolarCare Dashboard" menu="home" breadcrumbs={false}>
                <div className="content">
                    <div className="container-fluid"  style={{position: 'relative'}}>
                        <Loader isLoading={loading}/>

                        {/* <h5>Insights</h5> */}
                        <div className="row">
                            <div className="col-sm-6 col-md-4 col-lg-3 d-flex">
                                <Link className="info-box pointer" to="/product-units/list?status=OK">
                                    <span className="info-box-icon bg-success"><BsCheckCircleFill /></span>
                                    <div className="info-box-content">
                                        <span className="info-box-text mb-0 text-dark">OK</span>
                                        <h5 className="info-box-number mb-0 text-dark">{widget_data?.["OK"] || 0}</h5>
                                        <small className='text-muted'>No Issue</small>
                                    </div>
                                </Link>
                            </div>

                            <div className="col-sm-6 col-md-4 col-lg-3 d-flex">
                                <Link className="info-box pointer" to="/product-units/list?status=SERVICE">
                                    <span className="info-box-icon bg-warning"><BsWrenchAdjustable /></span>
                                    <div className="info-box-content">
                                        <span className="info-box-text text-dark">SERVICE</span>
                                        <h5 className="info-box-number mb-0 text-dark">{widget_data?.["SERVICE"] || 0}</h5>
                                        <small className='text-muted'>Active Service</small>
                                    </div>
                                </Link>
                            </div>

                            <div className="col-sm-6 col-md-4 col-lg-3 d-flex">
                                <Link className="info-box pointer" to="/product-units/list?status=CLEAN DUE">
                                    {/* <span className="info-box-icon bg-olive"><i className="fas fa-shopping-bag"></i></span> */}
                                    <span className="info-box-icon bg-orange"><GiBroom /></span>
                                    <div className="info-box-content">
                                        <span className="info-box-text text-dark">CLEAN DUE</span>
                                        <h5 className="info-box-number mb-0 text-dark">{widget_data?.["CLEAN DUE"] || 0}</h5>
                                        <small className='text-muted'>Due for Cleaning</small>
                                    </div>
                                </Link>
                            </div>

                            <div className="col-sm-6 col-md-4 col-lg-3 d-flex">
                                <Link className="info-box pointer" to="/product-units/list?status=CLEANED">
                                    <span className="info-box-icon bg-success"><BsCalendar2CheckFill /></span>
                                    <div className="info-box-content">
                                        <span className="info-box-text text-dark">CLEANED</span>
                                        <h5 className="info-box-number text-dark">{widget_data?.["CLEANED"] || 0}</h5>
                                        <small className='text-muted'>Recently Cleaned</small>
                                    </div>
                                </Link>
                            </div>

                            <div className="col-sm-6 col-md-4 col-lg-3 d-flex">
                                <Link className="info-box pointer" to="/product-units/list?status=OUT">
                                    <span className="info-box-icon bg-secondary"><VscSignOut /></span>
                                    <div className="info-box-content">
                                        <span className="info-box-text text-dark">OUT</span>
                                        <h5 className="info-box-number text-dark">{widget_data?.["OUT"] || 0}</h5>
                                        <small className='text-muted'>Decommissioned</small>
                                    </div>
                                </Link>
                            </div>
                        </div>


                    </div>{/* /.container-fluid */}
                </div>

        </Layout>
        </>
    )
}